<template>
  <div class="hunter_index">
    <div class="section" >
      <div class="page_banner pos_re w100 page_banner_930" style="background:url(../../static/img/index/banner1.png)">
        <div class="page_title dis_column ali_cen">
          <p :class="['page_title_text',anchorPage?'animation_bounceInUp':'']">三网企业视频彩铃</p>
          <p>为通话前每一秒等待赋予商业价值</p>
          <p class="page_title_des">GIVE BUSINESS VALUE TO EVERY SECOND OF WAITING BEFORE CALLING</p>
        </div>
        <div class="page1_content pos_re">
          <div class="page_content_video w100 pos_re dis_column ali_cen">
            <!-- <video src="../../static/img/video/1.mp4"  controls="false"  muted="muted" autoplay="autoplay" loop></video> -->
            <img :src=videoPageActive.img>
          </div>
          <div class="page1_content_con pos_re">
            <div class="page1_con_left">
              <div :class="['page1_con_LT',anchorCon?'ani_left':'']">
                <p class="page1_con_LT_text">{{videoPageActive.title}}</p>
                <p>{{videoPageActive.title_des}}</p>
              </div>
              <div :class="['page1_con_LB',anchorCon?'animate__fadeInUp':'']">
                <p>{{videoPageActive.content}}</p>
              </div>
            </div>
            <div class="page1_con_right dis_row">
              <div :class="['page1_con_RI dis_row just_cen',item.isActive ? 'page1_con_RI_isactive':'']" v-for="(item,index) in videoPageList" :key="index" @click="videoPageClick(item,index)">
                <p class="w100">{{item.title}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="page_banner pos_re w100 page_banner_930" >
        <div class="des_circle"></div>
        <div class="des_circle1"></div>
        <div class="des_circle2"></div>
        <div class="des_circle3"></div>
        <div class="page2_title dis_column ali_cen">
          <p :class="['page4_title_text color_333',ringonePage?'ani_left':'']">企业彩铃</p>
          <p :class="['color_333 page4_title_des',ringonePage?'ani_right':'']" class="">覆盖三大运营商的企业业务，企业宣传的有声名片</p>
        </div>
        <div class="page3_content">
          <div class="page4_con">
            <img src="../../static/img/index/banner2_img.png" class="w100 h100">
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="page3_banner pos_re w100 page_banner_930 dis_column ali_cen">
        <div class="page_title dis_column ali_cen">
          <p :class="['page_title_text',phonePage?'ani_right':'']">400电话</p>
          <p :class="[phonePage?'ani_left':'']">企业对外公布全国唯一的400号码，实现企业对外宣传的名片</p>
        </div>
        <div class="page3_content">
          <div class="dis_row just_bet flex_wrap card-list">
            <div class="card-item">
              <div class="card-content frontend" style="background:url(../../static/img/index/page3_bgi/1.png) center center no-repeat">
                <img src="../../static/img/index/page3_bgi/400_icon1.png" alt="" class="card-item-icon">
                <h4 class="card-item-title">统一热线</h4>
              </div>
              <div class="card-content backend">
                <h4 class="card-backend-title">统一热线</h4>
                <p class="card-desc">号码易记，记住号码等于记住公司，增加来电机会</p>
              </div>
            </div>
            <div class="card-item">
              <div class="card-content frontend" style="background:url(../../static/img/index/page3_bgi/2.png) center center no-repeat">
                <img src="../../static/img/index/page3_bgi/400_icon2.png" alt="" class="card-item-icon">
                <h4 class="card-item-title">解决来电占线</h4></div>
              <div class="card-content backend">
                <h4 class="card-backend-title">解决来电占线</h4>
                <p class="card-desc">多个客户同时拨打号码，实现同时接听，避免占线</p>
              </div>
            </div>
            <div class="card-item">
              <div class="card-content frontend" style="background:url(../../static/img/index/page3_bgi/3.png) center center no-repeat">
                <img src="../../static/img/index/page3_bgi/400_icon3.jpg" alt="" class="card-item-icon">
                <h4 class="card-item-title">搬家不换号</h4>
              </div>
              <div class="card-content backend">
                <h4 class="card-backend-title">搬家不换号</h4>
                <p class="card-desc">企业搬迁或员工离职，无需更换400号码，客户不流失</p>
              </div>
            </div>
            <div class="card-item" >
              <div class="card-content frontend" style="background:url(../../static/img/index/page3_bgi/4.png) center center no-repeat">
                <img src="../../static/img/index/page3_bgi/400_icon4.jpg" alt="" class="card-item-icon">
                <h4 class="card-item-title">通话录音</h4>
              </div>
              <div class="card-content backend">
                <h4 class="card-backend-title">通话录音</h4>
                <p class="card-desc">每一个400电话来电通话全程录音，帮助企业监督客服服务质量</p>
              </div>
            </div>
            <div class="card-item" >
              <div class="card-content frontend" style="background:url(../../static/img/index/page3_bgi/5.png) center center no-repeat">
                <img src="../../static/img/index/page3_bgi/400_icon5.jpg" alt="" class="card-item-icon">
                <h4 class="card-item-title">来电欢迎词</h4>
              </div>
              <div class="card-content backend">
                <h4 class="card-backend-title">来电欢迎词</h4>
                <p class="card-desc">企业的有声名片，用个性语音代替单调铃声，向客户传达企业真实信息，增加信任</p>
              </div>
            </div>
            <div class="card-item" >
              <div class="card-content frontend" style="background:url(../../static/img/index/page3_bgi/6.png) center center no-repeat">
                <img src="../../static/img/index/page3_bgi/400_icon6.jpg" alt="" class="card-item-icon">
                <h4 class="card-item-title">来电分析</h4>
              </div>
              <div class="card-content backend">
                <h4 class="card-backend-title">来电分析</h4>
                <p class="card-desc">自动记录每一个电话来电号码、区域、时间、通话时长，以及接听坐席号码等数据并分析。</p>
              </div>
            </div>
            <div class="card-item" >
              <div class="card-content frontend" style="background:url(../../static/img/index/page3_bgi/7.png) center center no-repeat">
                <img src="../../static/img/index/page3_bgi/400_icon7.jpg" alt="" class="card-item-icon">
                <h4 class="card-item-title">呼叫黑名单</h4>
              </div>
              <div class="card-content backend">
                <h4 class="card-backend-title">呼叫黑名单</h4>
                <p class="card-desc">把恶意号码列入黑名单，使其不能再次呼入400电话，防止恶意骚扰，方便管理省时省力省钱</p>
              </div>
            </div>
            <div class="card-item" >
              <div class="card-content frontend" style="background:url(../../static/img/index/page3_bgi/8.png) center center no-repeat">
                <img src="../../static/img/index/page3_bgi/400_icon8.jpg" alt="" class="card-item-icon">
                <h4 class="card-item-title">挂机短信</h4>
              </div>
              <div class="card-content backend">
                <h4 class="card-backend-title">挂机短信</h4>
                <p class="card-desc">通话结束后，系统自动发送一段设置好的短信到用户手机上，短信内容可在自行编辑设置</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="page_banner pos_re w100 page_banner_930" style="background:url(../../static/img/index/banner2.png)">
        <div class="page2_title dis_column ali_cen">
          <p :class="['page2_title_text color_333',certificationPage?'animation_bounceInUp':'']">号码认证</p>
          <p class="color_333 page2_title_des">消除陌生号码信任危机</p>
          <p class="color_333">用企业真实CIS信息取代陌生号码,让沟通简单可信高效</p>
        </div>
        <div class="banner2_phone dis_row just_cen w100">
          <img src="../../static/img/index/banner2_phone.png" alt="" >
        </div>
      </div>
    </div>
    <div class="section">
      <div class="page_banner pos_re w100 h100" style="background:url(../../static/img/index/banner5.jpg)">
        <div class="page_title dis_column ali_cen">
          <p :class="['page_title_text',cooperationPage?'ani_left':'']">共享创新/合作专业</p>
          <p :class="['page5_title_text',cooperationPage?'ani_right':'']">面向行业代理，我们提供安全、可靠、专业、易扩展的解决方案。我们整合资源、提高效率，以满足代理商业务快速发展的不同需求，从而帮助代理商取得更优渥的回报</p>
        </div>
        <div class="page5_content dis_row just_cen w100" >
          <div class="page5_content_item" v-for="(item,index) in advantageList" :key="index">
            <h3 class="txt color_333">{{item.title}}</h3>
            <div v-for="(i,num) in item.conList" :key="num">
              <div class="dis_row tit_div">
                <img :src=i.icon alt="">
                <h3 class="tit">{{i.title}}</h3>
              </div>
              <p class="page5_des">{{i.des}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pic_phone_1 from '../../static/img/index/pic_phone_1.png'
import pic_phone_2 from '../../static/img/index/pic_phone_2.png'
import pic_phone_3 from '../../static/img/index/pic_phone_3.png'
import pic_phone_4 from '../../static/img/index/pic_phone_4.png'
import pic_phone_5 from '../../static/img/index/pic_phone_5.png'
import pic_phone_6 from '../../static/img/index/pic_phone_6.png'

import icon_2 from '../../static/img/index/icon_2.png'
import icon_5 from '../../static/img/index/icon_5.png'
import icon_3 from '../../static/img/index/icon_3.png'
import icon_11 from '../../static/img/index/2-1-1.png'
import icon_12 from '../../static/img/index/2-3-1.png'
import icon_13 from '../../static/img/index/2-4-1.png'
import advan_icon2 from '../../static/img/index/400_advan_icon2.png'
import advan_icon4 from '../../static/img/index/400_advan_icon4.png'
import advan_icon1 from '../../static/img/index/400_advan_icon1.png'
    export default {
        name: "index",
      data () {
        return {
          anchorCon:false,
          anchorPage:false,
          ringonePage:false,
          phonePage:false,
          certificationPage:false,
          cooperationPage:false,
          videoPageActive:{
            img:pic_phone_1,
            title:'教育',
            title_des:'树立科学教育理念，培养新型人才',
            content:'学校：展示学校环境、配套设施、师资力量、位置信息；培训机构：宣传特色辅导课程、职业与技能培训课程等；',
            isActive:true
          },
          videoPageList:[{
            img:pic_phone_1,
            title:'教育',
            title_des:'树立科学教育理念，培养新型人才',
            content:'学校：展示学校环境、配套设施、师资力量、位置信息；培训机构：宣传特色辅导课程、职业与技能培训课程等',
            isActive:true
          },{
            img:pic_phone_2,
            title:'电商',
            title_des:'吸引客户，提高转化率',
            content:'线上电商平台、线下超市品牌推广；节假日促销活动宣传；结合新零售，帮助商家精准获客；退货等流程介绍',
            isActive:false
          },{
            img:pic_phone_3,
            title:'医疗',
            title_des:'连接医患双方，传递关键医疗信息',
            content:'领先技术宣传；电话挂号流程；讲解专家出诊时间信息；体检套餐优惠推广',
            isActive:false
          },{
            img:pic_phone_4,
            title:'金融',
            title_des:'推广理财产品，普及金融常识',
            content:'银行:品牌价值宣传，最新理财产品介绍；证券:公司优势宣传，精准客户营销；保险:保险观念普及，理赔流程介绍；投资公司:公司合法性、正规性宣传',
            isActive:false
          },{
            img:pic_phone_5,
            title:'互联网',
            title_des:'追逐娱乐，让绚丽酷出新高度',
            content:'这是一个娱乐至上的时代，视频彩铃自带有趣的娱乐属性，助力互联网行业客户快速拉新促活',
            isActive:false
          },{
            img:pic_phone_6,
            title:'房地产',
            title_des:'实业支撑，为销售打call',
            content:'房源信息发布，销售视频名片，增进与客户关系；房地产开发商:链家、中原等中介平台',
            isActive:false
          }],
          advantageList:[{
            title:'平台优势',
            conList:[{
              icon:icon_2,
              title:'三网平台',
              des:'强大技术保障贴心运营支持/平台多种业务无限发展下级代理/平台操作简单，高效快捷'
            },{
              icon:icon_5,
              title:'优质服务',
              des:'7*24h全天候客服在线/客服响应迅速/团队专业业务能力优秀/无中间商全网最高返佣'
            },{
              icon:icon_3,
              title:'数据可视化',
              des:'所有上传数据状态透明随时查看/保证渠道商平台号码隐私/运营商业务总代直接合作'
            }]
          },{
            title:'企业应用场景',
            conList:[{
              icon:advan_icon1,
              title:'提升企业形象',
              des:'一线员工/产线工人为企业员工提供【号码认证】服务，品牌展示'
            },{
              icon:advan_icon4,
              title:'业务拓展',
              des:'渠道商/销售部【400电话】号码不占线，接通快，商机不流失'
            },{
              icon:advan_icon2,
              title:'新品宣传',
              des:'管理层/合作伙伴可定制企业文化、品牌形象内容的【视频彩铃】'
            }]
          },{
            title:'代理业务',
            conList:[{
              icon:icon_11,
              title:'企业彩铃/视频彩铃',
              des:'将固定电话或手机的普通铃音替换成音乐广告或视频的增值服务'
            },{
              icon:icon_12,
              title:'号码认证',
              des:'通过手机号码或固话信息认证，展示真实信息，提升意向接通率'
            },{
              icon:icon_13,
              title:'400电话',
              des:'企业对外公布全国唯一的400号码，实现企业对外宣传的名片'
            }]
          }],//平台优势
          productsList:[{
            name:'企业彩铃，视频彩铃',
            // url:"/ringone"
          },{
            name:'视频彩铃制作',
            // url:"/video_ringone"
          },{
            name:'400电话',
            // url:"/telNum"
          },{
            name:'号码认证',
            url:""
          },{
            name:'铃音录制',
            // url:"/ringoneRecord"
          }],
          cooperationList:[{
            name:'代理产品',
            url:"/cooperation"
          },{
            name:'合作流程',
            url:"/cooperation"
          },{
            name:'代理支撑',
            url:"/cooperation"
          }],
          usList:[{
            name:'公司简介',
            url:'/aboutUs'
          },{
            name:'企业文化',
            url:'/aboutUs'
          },{
            name:'服务优势',
            url:'/aboutUs'
          },{
            name:'平台简介',
            url:'/aboutUs'
          }],
          options: {
            licenseKey: 'YOUR_KEY_HERE',
            afterLoad: this.afterLoad,
            scrollOverflow: true,
            scrollBar: false,
            menu: '#menu',
            navigation: true,
            anchors: ['page1', 'page2', 'page3','page4','page5','page6'],
            // sectionsColor: ['#41b883', '#ff5f45', '#0798ec', '#fec401', '#1bcee6', '#ee1a59', '#2c3e4f', '#ba5be9', '#b4b8ab']
          }
        }
      },
      created(){
        this.anchorCon = true;
        this.anchorPage = true
      },
      mounted () {
        window.addEventListener('scroll', this.scrollToTop)
      },
      destroyed () {
        window.removeEventListener('scroll', this.scrollToTop)
      },
      methods: {
        videoPageClick(item,index){
          this.videoPageList.forEach((i)=>{
            i.isActive = false
          })
          this.anchorCon = false;
          setTimeout(()=>{
            this.anchorCon = true;
            this.videoPageActive = item;
            this.videoPageList[index].isActive = true
          })
        },
        jumpPath(path){
          if(path){
            this.$router.replace(path)
          }
        },
        afterLoad (obj) {
          this.anchorPage = false
          this.ringonePage = false
          this.phonePage = false
          this.certificationPage = false
          this.cooperationPage = false
          setTimeout(()=>{
            if(obj.index ==0){
              this.anchorPage = true
              this.ringonePage = true
            }else if(obj.index ==1){
              this.anchorPage = true
              this.phonePage = true
            }else if(obj.index ==2){
              this.ringonePage = true
              this.certificationPage = true
            }else if(obj.index ==3){
              this.phonePage = true
              this.cooperationPage = true
            }else if(obj.index ==4){
              this.certificationPage = true
            }if(obj.index ==5){
              this.cooperationPage = true
            }

          },100)
          
        },
        scrollToTop () {
          const that = this
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
          if(scrollTop<100){
            this.anchorPage = true
          }else if(400< scrollTop&& scrollTop<865){
            this.ringonePage = true
          }else if(1300< scrollTop&& scrollTop<1860){
            this.phonePage = true
          }else if(2300< scrollTop&& scrollTop<2865){
            this.certificationPage = true
          }else if(3300< scrollTop&& scrollTop<3730){
            this.cooperationPage = true
          }


          if(scrollTop>600 ){
            this.anchorPage = false
          }
          if(1600< scrollTop ){
            this.ringonePage = false
          }
          if(2600< scrollTop){
            this.phonePage = false
          }
          if(3600< scrollTop){
            this.certificationPage = false
          }
          if(4300< scrollTop||scrollTop<2500){
            this.cooperationPage = false
          }
        }
      }
    }
</script>

<style scoped>
  .section{
    overflow: hidden;
    width: 1920px;
    height: 100%;
  }
  .page_banner{
    background-size: 100% 100% !important;
  }
  .page_banner_930{
    height: 950px;
  }
  .page_title{
    font-size: 20px;
    color: #ffffff;
    /* padding-top: 3.4vw; */
    padding-top: 70px;
  }
  .page2_title{
      font-size: 20px;
      color: #ffffff;
      /* padding-top: 4.5vw; */
      padding-top: 90px;
      line-height: 35px;
  }
  .page2_title_des,.page4_title_des{
    /* margin-top: 2.5vh; */
    margin-top:25px
  }
  .page4_title_des{
    opacity: 0;
  }
  .page2_title_text{
    /* margin-top: 8vh;
    margin-bottom: 1vh; */
    margin-top: 80px;
    margin-bottom: 10px;
    font-size: 45px;
    font-weight: bolder;
    opacity: 0;
  }
  .page4_title_text{
    /* margin-top: 6vh; */
    margin-top: 60px;
    font-size: 35px;
    font-weight: bolder;
    opacity: 0;
  }
  .page_title_text{
    /* margin-top: 8vh;
    margin-bottom: 3vh; */
    margin-top: 80px;
    margin-bottom: 30px;
    font-size: 45px;
    font-weight: bolder;
     opacity: 0;
  }
  .animation_bounceInUp{
    opacity: 1;
    animation: bounceInUp 1.5s ease forwards;
  }
  .page_title_des{
    /* margin-top: 0.8vh; */
    margin-top: 8px;
    font-size: 16px;
    font-weight: bolder;
  }
  .page_content_video{
    /* margin-top: 4vw; */
    margin-top:135px;
    /* height: 600px; */
  }
  .page_content_video img{
    width: 350px;
    height: 600px;
    position: absolute;
    top: -60px;
    left: 48%;
  }
  .page1_content_con{
    position: absolute;
    width: 100vw;
    position: absolute;
    left: 0;
    /* top: 5vw; */
    top:10px
  }
  .page1_con_left{
    width: 550px;
    height: 450px;
    position: absolute;
    left: 15%;
    top: 0;
  }
  .page1_con_LT{
    padding-top: 20px;
    width: 550px;
    height: 130px;
    font-size: 18px;
    color: rgba(255,255,255,1);
    opacity: 0;
  }
  .page1_con_LT_text{
    margin-bottom: 16px;
    font-size: 48px;
    font-weight: 600;
    color: rgba(255,255,255,1);
  }
  .page1_con_right{
    width: 500px;
    height: 250px;
    position: absolute;
    right: 5%;
    top: 175px;
  }
  .page1_con_LB{
    width: 100%;
    font-size: 18px;
    color: rgba(109,114,120,1);
    line-height: 30px;
    margin-top: 80px;
  }
  .page1_con_RI{
    width: 55px;
    height: 220px;
    margin-right: 10px;
    font-size: 18px;
    color: rgba(200,206,220,1);
    font-weight: 500;
    text-align: center;
    padding-top: 50px;
  }
  .page1_con_RI p{
    width: 25px;
  }
  .page1_con_RI_isactive{
    background: url(../../static/img/index/pic_selected@2x.png);
    background-size: 100%;
    background-repeat: no-repeat;
    font-size: 24px;
  }
  .page1_con_RI_isactive p,.page1_con_RI:hover p{
    font-weight: 600;
    color: rgba(0,0,0,0.85);
    transition: all .2s;
  }
  .banner2_phone{
    height: 566px;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .banner2_phone img{
    width: 1365px;
    height: 566px;
  }
  .page3_banner{
    background: url('../../static/img/index/banner3.png') #282b48 center center no-repeat;
  }
  .page3_content{
    width: 1200px;
    margin: 0 auto;
    text-align: center;
  }
  .page5_content{
    margin: 0 auto;
    margin-top: 50px;
    padding-bottom: 50px;
    width: 1200px;
    text-align: center;
  }
  .page5_content_item{
    /* box-shadow: 0.42vw 0.42vw 1.09vw rgba(239, 239, 239, .56); */
    padding: 40px 34px 20px;
    background-color: #ffffff;
    margin:0 15px;
    transition: all .6s;
  }
  .page5_content_item:hover{
    transition: all .6s;
    transform: translateY(-20px);
  }
  .page4_con{
    width: 1200px;
    margin: 50px auto 0;
    height: 600px;
  }
  .card-list{
    margin-top: 50px;
  }
  .card-item {
    width: 290px;
    height: 285px;
    margin-bottom: 12px;
    box-sizing: border-box;
    text-align: left;
    position: relative;
    perspective: 1000;
    -webkit-perspective: 1000;
    margin: 5px;
}
.card-list .card-content.frontend {
    background: #fff !important;
    overflow: hidden;
    border-radius: 15px;
}
.card-list .card-content {
    padding: 25px;
    box-sizing: border-box;
    position: absolute;
    height: 100%;
    width: 100%;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    transform-style: preserve-3d;
    -webkit-transform-style: preserve-3d;
    transition: ease-in-out 600ms;
}
.card-list .card-item:hover .frontend {
    transform: rotateY(180deg);
}
.card-list .card-item:hover .backend {
    transform: rotateY(0deg);
}
.card-list .card-content.backend {
    color: #fff;
    background: #4a81ff;
    border-radius: 15px;
    transform: rotateY(-180deg);
}
.card-content .card-item-icon {
    height: 55px;
}
 .card-list .card-item-title {
    font-size: 16px;
    color: #1a1d3c;
    font-weight: 500;
    margin-top: 10px;
}
.card-list .card-content .card-item-title {
    font-size: 20px;
}
.card-list .card-content.backend .card-backend-title {
    color: #fff;
    font-size: 23px;
    font-weight: 500;
    margin:20px 0
}
.card-list .card-content.backend .card-desc {
    font-size: 14px;
    line-height: 22px;
    opacity: .8;
}
.page5_title_text{
  width: 800px;
  text-align: center;
  font-size: 16px;
  line-height: 30px;
  opacity: 0;
}
.txt{
  font-size: 24px;
  margin-bottom:30px;
  text-align: left;
}
.tit_div{
  margin-bottom:10px;
  align-items: flex-end;
}
.tit_div img{
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.tit{
  font-size: 18px;
}
.page5_des{
  font-size: 14px;
  color: #666;
  line-height: 24px;
  height: 55px;
  overflow: hidden;
  width: 300px;
  text-align: left;
  margin-bottom:40px
}











  .page_content_video video{
    width: 340px;
    height: 480px;
    /* margin-left: 10px; */
    margin-top: 35px;
    position: absolute;
    top: 0;
    left: 50%;
  }
  .page_content_video video::-webkit-media-controls{
        display:none !important;
  }


  @keyframes bounceInUp {
    from, 60%, 90%, to {
        -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
        animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    }
    from {
        opacity: 0;
        -webkit-transform: translate3d(0, -5.208333rem, 0);
        transform: translate3d(0, -5.208333rem, 0);
    }
    60% {
        opacity: 1;
        -webkit-transform: translate3d(0, -0.104167rem, 0);
        transform: translate3d(0, -0.104167rem, 0);
    }
    90% {
        -webkit-transform: translate3d(0, -0.026042rem, 0);
        transform: translate3d(0, -0.026042rem, 0);
    }
    to {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
        opacity: 1;
    }
  }


  .des_circle{
        position: absolute;
        top: 25vw;
        left: 8vw;
        transform: translate(-50%,-50%);
        opacity: .5;
        border-radius: 50%;
        width: 15vw;
        height: 15vw;
        border: 4px solid #d1eaf3;
        background-color:  #d1eaf3;
        animation:mymove1 25s infinite;
    }
    .des_circle2{
        position: absolute;
        top: 10vw;
        right: -10vw;
        animation:mymove3 25s infinite;
        transform: translate(-50%,-50%);
        opacity: .3;
        border-radius: 50%;
        width: 25vw;
        height: 25vw;
        border: 4px solid #d1eaf3;
        background-color:  #d1eaf3;
    }
    .des_circle1{
        position: absolute;
        top: 10vw;
        left: 0%;
        transform: translate(-50%,-50%);
        opacity: .5;
        border-radius: 50%;
        width: 5vw;
        height: 5vw;
        border: 4px solid #d1eaf3;
        background-color:  #d1eaf3;
        animation:mymove2 35s infinite;
    }
    .des_circle3{
        position: absolute;
        top: 40vw;
        right: 20vw;
        animation:mymove3 25s infinite;
        transform: translate(-50%,-50%);
        opacity: .3;
        border-radius: 50%;
        width: 25vw;
        height: 25vw;
        border: 4px solid #d1eaf3;
        background-color:  #d1eaf3;
    }
    @media screen and (min-width: 1100px) {
        .ringone_con_banner_con1:hover{
            transform: translateY(-15px);
        }
        .ringone_con_banner_con:hover,.ringone_con_advantage:hover{
            transform: translateY(-15px);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue